import React, { Component } from "react";
import { Input } from "reactstrap";

class InputAutoComplete extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: props.value || "",
      highlightedIndex: -1, 
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        showSuggestions: false,
        highlightedIndex: -1, 
      });
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    // Update userInput when the value prop changes
    if (prevProps.value !== this.props.value) {
      this.setState({
        userInput: this.props.value || "",
        highlightedIndex: -1,
      }, () => {
        this.filterSuggestions(this.props.value);
      });
    }
  }

  filterSuggestions = (input) => {
    const { data } = this.props;

    const filteredSuggestions = input
      ? data.filter((item) => item.toLowerCase().includes(input.toLowerCase()))
      : data; 

    this.setState({
      filteredSuggestions,
      highlightedIndex: -1, 
    });
  };

  handleChange = (e) => {
    const userInput = e.currentTarget.value;

    this.setState({
      userInput,
      highlightedIndex: -1,
      showSuggestions  : true,
    }, () => {
      this.filterSuggestions(userInput);
      this.props.onValueChange(userInput);
    });
  };

  handleClick = (value) => {
    this.setState(
      {
        userInput: value,
        filteredSuggestions: [],
        showSuggestions: false,
        highlightedIndex: -1, 
      },
      () => this.props.onValueChange(value)
    );
  };

  handleKeyDown = (e) => {    
    const { userInput, filteredSuggestions, highlightedIndex } = this.state;

    if (e.key === "Enter" && userInput) {
      this.setState(
        {
          showSuggestions: false,
          filteredSuggestions: [],
          highlightedIndex: -1,
        },
        () => this.props.onValueChange(userInput)
      );
    }

    if (e.key === "ArrowDown") {
      if (highlightedIndex < filteredSuggestions.length - 1) {
        this.setState((prevState) => ({
          highlightedIndex: prevState.highlightedIndex + 1,
        }));
      }
      e.preventDefault(); 
    }

    if (e.key === "ArrowUp") {
      if (highlightedIndex > 0) {
        this.setState((prevState) => ({
          highlightedIndex: prevState.highlightedIndex - 1,
        }));
      }
      e.preventDefault();
    }

    if (e.key === "Enter" && highlightedIndex >= 0) {
      const selectedSuggestion = filteredSuggestions[highlightedIndex];
      this.handleClick(selectedSuggestion);
    }
  };

  handleFocus = () => {
    const { userInput } = this.state;

    this.setState({
      showSuggestions: true,
      filteredSuggestions: userInput
        ? this.props.data.filter((item) => item.toLowerCase().includes(userInput.toLowerCase()))
        : this.props.data,
    });
  };

  renderSuggestions = () => {
    const { showSuggestions, filteredSuggestions, highlightedIndex } = this.state;

    if (showSuggestions) {
      if (filteredSuggestions.length) {
        return (
          <ul className="input_suggestions">
            {filteredSuggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => this.handleClick(suggestion)}
                className={highlightedIndex === index ? 'highlighted' : ''}
              >
                {suggestion}
              </li>
            ))}
          </ul>
        );
      } else {
        return (
          <div className="input_suggestions">
            <ul>
              <li className="disabled">No suggestions available.</li>
            </ul>
          </div>
        );
      }
    }
    return null;
  };

  render() {
    const { placeholder } = this.props;
    const { userInput } = this.state;

    return (
      <div className="Main" ref={this.wrapperRef}>
        <div className="input-group">
          <Input
            type="text"
            className="AutoComplete custom_input"
            placeholder={placeholder}
            value={userInput}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocus}
            disabled={this.props.isDasable}
          />
          {this.renderSuggestions()}
        </div>
      </div>
    );
  }
}

export default InputAutoComplete;
